
<template>
    <div class="page">
      <Header></Header>
      <div class="box-split"></div>
      <div class="body">
        <div class="box2-title">
          <span style="color:#F25058;margin-right: 4px;height: 14px;">*</span>
          附件简历
          <span class="box2-title-text-sub">（请上传简历，在完善个人信息)</span>
        </div>
        <div v-if="!loading && !resumePath" class="uploadbox">
          <van-uploader :accept="accept" :max-count="1" :max-size="maxFile" :before-read="onBeforeReadFile" :after-read="onAfterReadFile">
            <img :src="require('@/assets/add.png')" class="upload-icon" />
            <div class="upload-text">点击上传附件简历</div>
            <div class="upload-text-sub">支持格式：pdf、doc、docx</div>
          </van-uploader>
        </div>
        <div v-if="!loading && resumePath" class="filebox">
            <img :src="require('@/assets/file/'+fileIcon+'.png')" class="filebox-icon" />
            <div class="filebox-name">{{resumeDetail.Name?resumeDetail.Name+"的简历":"简历"}}</div>
            <van-uploader :accept="accept" :max-count="1" :max-size="maxFile" :before-read="onBeforeReadFile" :after-read="onAfterReadFile">
              <div class="filebox-btns">
                 重新上传
              </div>
            </van-uploader>
        </div>
        <div class="box-split"></div>
        <div class="box2-title">
          <span class="box2-title-icon"></span>
          个人信息
        </div>
        <div class="box2-title-text">基础信息</div>
        <div class="box2">
            <van-field v-model="resumeDetail.Name" maxlength="100" required label="姓名　　" placeholder="请输入姓名" />
            <van-field v-model="resumeDetail.Mobile" maxlength="11" required label="手机号　" placeholder="请输入手机号码" />
            <van-field v-model="resumeDetail.Email" maxlength="200" required label="邮箱　　" placeholder="请输入邮箱" />
            <van-field v-model="resumeDetail.Sex" required label="性別　　" placeholder="请选择性別" :right-icon="require('@/assets/dropdown.png')" readonly clickable @click.native="showPopup($event,resumeDetail,'sex')" />
        </div>
        <div style="height: 1px"></div>
        <div v-for="(item,i) in resumeDetail.EducationInfo" :key="'edu'+i">
            <div class="box-split"></div>
            <div v-if="i==0" class="box2-title-text">教育经历<span class="box2-title-text-sub">（请从本科学历开始填写)</span></div>
            <div class="box2">
                <van-field v-model="item.School" maxlength="100" required label="毕业院校" placeholder="请输入毕业院校" />
                <van-field v-model="item.Speciality" maxlength="100" required label="专业　　" placeholder="请输入专业" />
                <van-field v-model="item.StartDate" required label="开始时间" placeholder="请选择开始时间" :right-icon="require('@/assets/calendar.png')" readonly clickable @click.native="showStartDatePopup($event,item)" />
                <van-field v-model="item.EndDate" required label="结束时间" placeholder="请选择结束时间" :right-icon="require('@/assets/calendar.png')" readonly clickable @click.native="showEndDatePopup($event,item)" />
                <van-field v-model="item.Education" required label="学历　　" placeholder="请选择学历" :right-icon="require('@/assets/dropdown.png')" readonly clickable @click.native="showPopup($event,item,'edu')" />
                <van-field v-model="item.studyType" required label="是否统招" placeholder="请选择是否统招" :right-icon="require('@/assets/dropdown.png')" readonly clickable @click.native="showPopup($event,item,'study')" />
                <van-field class="pr" v-model="item.professionRanking" required label="专业排名" placeholder="请选择专业排名" :right-icon="require('@/assets/dropdown.png')" readonly clickable @click.native="showPopup($event,item,'prof')" />
                <div style="padding: 0 0 16px;"><!--请如实填写，面试时需携带相关材料--></div>
            </div>
            <div v-if="resumeDetail.EducationInfo.length==1" class="box2-btns">
              <van-button class="box2-btn-add" :icon="require('@/assets/plus.png')" @click="onAddEdu">
                添加教育经历
              </van-button>
            </div>
            <div v-if="resumeDetail.EducationInfo.length>1 && i!=resumeDetail.EducationInfo.length-1" class="box2-btns">
              <van-button class="box2-btn-del" :icon="require('@/assets/delete.png')" @click.native="onDelEdu($event,i)">
                删除教育经历
              </van-button>
            </div>
            <div v-if="resumeDetail.EducationInfo.length>1 && i==resumeDetail.EducationInfo.length-1" class="box2-btns">
              <van-button  class="box2-btn-del" :icon="require('@/assets/delete.png')" @click.native="onDelEdu($event,i)">
                删除教育经历
              </van-button>
              <div style="width:12px;"/>
              <van-button class="box2-btn-add" :icon="require('@/assets/plus.png')" @click.native="onAddEdu">
                添加教育经历
              </van-button>
            </div>
        </div>
<!--        <div style="height: 1px"></div>-->
<!--        <div v-for="(item,i) in resumeDetail.internshipInfo" :key="'intern'+i">-->
<!--          <div class="box-split"></div>-->
<!--          <div v-if="i==0" class="box2-title-text">实习经历</div>-->
<!--          <div class="box2">-->
<!--            <van-field v-model="item.compayName" required label="企业名称" placeholder="请输入企业名称" />-->
<!--            <van-field v-model="item.title" required label="所任职位" placeholder="请输入所任职位" />-->
<!--            <van-field v-model="item.startDate" required label="开始时间" placeholder="请选择开始时间" :right-icon="require('@/assets/calendar.png')" readonly clickable @click.native="showStartDatePopup($event,item)" />-->
<!--            <van-field v-model="item.endDate" required label="结束时间" placeholder="请选择结束时间" :right-icon="require('@/assets/calendar.png')" readonly clickable @click.native="showEndDatePopup($event,item)" />-->
<!--            <van-field v-model="item.jobDetail" required label="工作描述" class="textarea" type="textarea" rows="5" placeholder="请输入工作描述" />-->
<!--          </div>-->
<!--          <div v-if="resumeDetail.internshipInfo.length>1 && i!=resumeDetail.internshipInfo.length-1" class="box2-btns">-->
<!--            <van-button  class="box2-btn-del" :icon="require('@/assets/delete.png')" @click.native="onDelIntern($event,i)">-->
<!--              删除实习经历-->
<!--            </van-button>-->
<!--          </div>-->
<!--          <div v-if="i==resumeDetail.internshipInfo.length-1" class="box2-btns">-->
<!--            <van-button  class="box2-btn-del" :icon="require('@/assets/delete.png')" @click.native="onDelIntern($event,i)">-->
<!--              删除实习经历-->
<!--            </van-button>-->
<!--            <div style="width:12px;"/>-->
<!--            <van-button class="box2-btn-add" :icon="require('@/assets/plus.png')" @click.native="onAddIntern">-->
<!--              添加实习经历-->
<!--            </van-button>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div v-if="!resumeDetail.internshipInfo || resumeDetail.internshipInfo.length==0">-->
<!--          <div class="box-split"></div>-->
<!--          <div class="box2-title-text">实习经历</div>-->
<!--          <div class="box2">-->
<!--            <div class="box2-btns">-->
<!--              <van-button class="box2-btn-add" :icon="require('@/assets/plus.png')" @click.native="onAddIntern">-->
<!--                添加实习经历-->
<!--              </van-button>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
        <div style="height: 1px"></div>
        <div v-for="(item,i) in resumeDetail.ExperienceInfo" :key="'job'+i">
            <div class="box-split"></div>
            <div v-if="i==0" class="box2-title-text">实习/工作经历</div>
            <div class="box2">
                <van-field v-model="item.Company" maxlength="100" required label="企业名称" placeholder="请输入企业名称" />
                <van-field v-model="item.Title" maxlength="100" required label="所任职位" placeholder="请输入所任职位" />
                <van-field v-model="item.StartDate" required label="开始时间" placeholder="请选择开始时间" :right-icon="require('@/assets/calendar.png')" readonly clickable @click.native="showStartDatePopup($event,item)" />
                <van-field v-model="item.EndDate" required label="结束时间" placeholder="请选择结束时间" :right-icon="require('@/assets/calendar.png')" readonly clickable @click.native="showEndDatePopup($event,item)" />
                <van-field v-model="item.Summary" maxlength="500" required label="工作描述" class="textarea" type="textarea" rows="5" placeholder="请输入工作描述" />
            </div>
            <div v-if="resumeDetail.ExperienceInfo.length>1 && i!=resumeDetail.ExperienceInfo.length-1" class="box2-btns">
              <van-button  class="box2-btn-del" :icon="require('@/assets/delete.png')" @click.native="onDelJob($event,i)">
                删除工作经历
              </van-button>
            </div>
            <div v-if="i==resumeDetail.ExperienceInfo.length-1" class="box2-btns">
              <van-button  class="box2-btn-del" :icon="require('@/assets/delete.png')" @click.native="onDelJob($event,i)">
                删除工作经历
              </van-button>
              <div style="width:12px;"/>
              <van-button class="box2-btn-add" :icon="require('@/assets/plus.png')" @click.native="onAddJob">
                添加工作经历
              </van-button>
            </div>
        </div>
        <div v-if="!resumeDetail.ExperienceInfo || resumeDetail.ExperienceInfo.length==0">
          <div class="box-split"></div>
          <div class="box2-title-text">实习/工作经历</div>
          <div class="box2">
            <div class="box2-btns">
              <van-button class="box2-btn-add" :icon="require('@/assets/plus.png')" @click.native="onAddJob">
                添加工作经历
              </van-button>
            </div>
          </div>
        </div>
        <div style="height: 1px"></div>
        <div v-for="(item,i) in resumeDetail.ProjectInfo" :key="'pro'+i">
            <div class="box-split"></div>
            <div v-if="i==0" class="box2-title-text">项目经历</div>
            <div class="box2">
                <van-field v-model="item.ProjectName" maxlength="100" required label="项目名称" placeholder="请输入项目名称" />
                <van-field v-model="item.Title" maxlength="100" required label="项目角色" placeholder="请输入项目角色" />
                <van-field v-model="item.StartDate" required label="开始时间" placeholder="请选择开始时间" :right-icon="require('@/assets/calendar.png')" readonly clickable @click.native="showStartDatePopup($event,item)" />
                <van-field v-model="item.EndDate" required label="结束时间" placeholder="请选择结束时间" :right-icon="require('@/assets/calendar.png')" readonly clickable @click.native="showEndDatePopup($event,item)" />
                <van-field v-model="item.ProjectDescription" maxlength="500" required label="项目描述" class="textarea" type="textarea" rows="5" placeholder="请输入项目描述" />
<!--                <van-field v-model="item.Responsibilities" required label="项目职责" class="textarea" type="textarea" rows="5" placeholder="请输入项目职责" />-->
            </div>
            <div v-if="resumeDetail.ProjectInfo.length>1 && i!=resumeDetail.ProjectInfo.length-1" class="box2-btns">
              <van-button  class="box2-btn-del" :icon="require('@/assets/delete.png')" @click.native="onDelPro($event,i)">
                删除项目经历
              </van-button>
            </div>
            <div v-if="i==resumeDetail.ProjectInfo.length-1" class="box2-btns">
            <van-button  class="box2-btn-del" :icon="require('@/assets/delete.png')" @click.native="onDelPro($event,i)">
              删除项目经历
            </van-button>
            <div style="width:12px;"/>
            <van-button class="box2-btn-add" :icon="require('@/assets/plus.png')" @click.native="onAddPro">
              添加项目经历
            </van-button>
          </div>
        </div>
        <div v-if="!resumeDetail.ProjectInfo || resumeDetail.ProjectInfo.length==0">
            <div class="box-split"></div>
            <div class="box2-title-text">项目经历</div>
            <div class="box2">
                <div class="box2-btns">
                    <van-button class="box2-btn-add" :icon="require('@/assets/plus.png')" @click.native="onAddPro">
                        添加项目经历
                    </van-button>
                </div>
            </div>
        </div>
        <div style="height: 1px"></div>
        <div v-for="(item,i) in resumeDetail.worksInfo" :key="'work'+i">
          <div class="box-split"></div>
          <div v-if="i==0" class="box2-title-text">作品</div>
          <div class="box2">
            <van-field v-model="item.url" required label="作品链接" maxlength="1000" placeholder="请输入作品链接" />
            <van-field v-model="item.description" label="作品描述" maxlength="500" class="textarea" type="textarea" rows="5" placeholder="请输入作品描述" />
          </div>
          <div v-if="resumeDetail.worksInfo.length>1 && i!=resumeDetail.worksInfo.length-1" class="box2-btns">
            <van-button  class="box2-btn-del" :icon="require('@/assets/delete.png')" @click.native="onDelWorks($event,i)">
              删除作品
            </van-button>
          </div>
          <div v-if="i==resumeDetail.worksInfo.length-1" class="box2-btns">
            <van-button  class="box2-btn-del" :icon="require('@/assets/delete.png')" @click.native="onDelWorks($event,i)">
              删除作品
            </van-button>
            <div style="width:12px;"/>
            <van-button class="box2-btn-add" :icon="require('@/assets/plus.png')" @click.native="onAddWorks">
              添加作品
            </van-button>
          </div>
        </div>
        <div v-if="!resumeDetail.worksInfo || resumeDetail.worksInfo.length==0">
          <div class="box-split"></div>
          <div class="box2-title-text">作品</div>
          <div class="box2">
            <div class="box2-btns">
              <van-button class="box2-btn-add" :icon="require('@/assets/plus.png')" @click.native="onAddWorks">
                添加作品
              </van-button>
            </div>
          </div>
        </div>
        <div style="height: 1px"></div>
        <div v-for="(item,i) in resumeDetail.contestInfo" :key="'cont'+i">
          <div class="box-split"></div>
          <div v-if="i==0" class="box2-title-text">竞赛</div>
          <div class="box2">
            <van-field v-model="item.name" maxlength="100" required label="竞赛名称" placeholder="请输入竞赛名称" />
            <van-field v-model="item.description" maxlength="500" label="说明" class="textarea" type="textarea" rows="5" placeholder="请输入竞赛描述" />
          </div>
          <div v-if="resumeDetail.contestInfo.length>1 && i!=resumeDetail.contestInfo.length-1" class="box2-btns">
            <van-button  class="box2-btn-del" :icon="require('@/assets/delete.png')" @click.native="onDelCont($event,i)">
              删除竞赛
            </van-button>
          </div>
          <div v-if="i==resumeDetail.contestInfo.length-1" class="box2-btns">
            <van-button  class="box2-btn-del" :icon="require('@/assets/delete.png')" @click.native="onDelCont($event,i)">
              删除竞赛
            </van-button>
            <div style="width:12px;"/>
            <van-button class="box2-btn-add" :icon="require('@/assets/plus.png')" @click.native="onAddCont">
              添加竞赛
            </van-button>
          </div>
        </div>
        <div v-if="!resumeDetail.contestInfo || resumeDetail.contestInfo.length==0">
          <div class="box-split"></div>
          <div class="box2-title-text">竞赛</div>
          <div class="box2">
            <div class="box2-btns">
              <van-button class="box2-btn-add" :icon="require('@/assets/plus.png')" @click.native="onAddCont">
                添加竞赛
              </van-button>
            </div>
          </div>
        </div>
        <div style="height: 1px"></div>
        <div v-for="(item,i) in resumeDetail.certificateInfo" :key="'cert'+i">
          <div class="box-split"></div>
          <div v-if="i==0" class="box2-title-text">证书</div>
          <div class="box2">
            <van-field v-model="item.name" maxlength="100" required label="证书名称" placeholder="请输入证书名称" />
            <van-field v-model="item.description" maxlength="500" label="说明" class="textarea" type="textarea" rows="5" placeholder="请输入证书描述" />
          </div>
          <div v-if="resumeDetail.certificateInfo.length>1 && i!=resumeDetail.certificateInfo.length-1" class="box2-btns">
            <van-button  class="box2-btn-del" :icon="require('@/assets/delete.png')" @click.native="onDelCert($event,i)">
              删除证书
            </van-button>
          </div>
          <div v-if="i==resumeDetail.certificateInfo.length-1" class="box2-btns">
            <van-button  class="box2-btn-del" :icon="require('@/assets/delete.png')" @click.native="onDelCert($event,i)">
              删除证书
            </van-button>
            <div style="width:12px;"/>
            <van-button class="box2-btn-add" :icon="require('@/assets/plus.png')" @click.native="onAddCert">
              添加证书
            </van-button>
          </div>
        </div>
        <div v-if="!resumeDetail.certificateInfo || resumeDetail.certificateInfo.length==0">
          <div class="box-split"></div>
          <div class="box2-title-text">证书</div>
          <div class="box2">
            <div class="box2-btns">
              <van-button class="box2-btn-add" :icon="require('@/assets/plus.png')" @click.native="onAddCert">
                添加证书
              </van-button>
            </div>
          </div>
        </div>
        <div style="height: 1px"></div>
        <div v-for="(item,i) in resumeDetail.LanguagesSkills" :key="'lang'+i">
          <div class="box-split"></div>
          <div v-if="i==0" class="box2-title-text">语言</div>
          <div class="box2">
            <van-field v-model="item.langtype" required label="语言种类" placeholder="请选择语言种类" :right-icon="require('@/assets/dropdown.png')" readonly clickable @click.native="showPopup($event,item,'lang')" />
            <template v-if="item.langtype=='英语'">
            <van-field v-model="item.grade" required label="等级　　" placeholder="请选择等级" :right-icon="require('@/assets/dropdown.png')" readonly clickable @click.native="showPopup($event,item,'grade')" />
            <van-field v-model="item.Score" required label="分数　　" placeholder="请输入分数" />
            </template>
            <template v-else>
            <van-field v-model="item.Languages" maxlength="100" required label="语言　　" placeholder="请输入语言" />
            <van-field v-model="item.Skills" required label="精通程度" placeholder="请选择精通程度" :right-icon="require('@/assets/dropdown.png')" readonly clickable @click.native="showPopup($event,item,'skill')" />
            </template>
          </div>
          <div v-if="resumeDetail.LanguagesSkills.length>1 && i!=resumeDetail.LanguagesSkills.length-1" class="box2-btns">
            <van-button  class="box2-btn-del" :icon="require('@/assets/delete.png')" @click.native="onDelLang($event,i)">
              删除语言
            </van-button>
          </div>
          <div v-if="i==resumeDetail.LanguagesSkills.length-1" class="box2-btns">
            <van-button  class="box2-btn-del" :icon="require('@/assets/delete.png')" @click.native="onDelLang($event,i)">
              删除语言
            </van-button>
            <div style="width:12px;"/>
            <van-button class="box2-btn-add" :icon="require('@/assets/plus.png')" @click.native="onAddLang">
              添加语言
            </van-button>
          </div>
        </div>
        <div v-if="!resumeDetail.LanguagesSkills || resumeDetail.LanguagesSkills.length==0">
          <div class="box-split"></div>
          <div class="box2-title-text">语言能力</div>
          <div class="box2">
            <div class="box2-btns">
              <van-button class="box2-btn-add" :icon="require('@/assets/plus.png')" @click.native="onAddLang">
                添加语言
              </van-button>
            </div>
          </div>
        </div>
        <div style="height: 114px;"></div>
        <SafeBottom></SafeBottom>
      </div>
      <div class="bottom-btns">
          <button class="bottom-btn" @click="saveResume">保存</button>
      </div>
      <Footer></Footer>
      <van-popup v-model="showStartDatePicker" round position="bottom">
          <van-datetime-picker
                  v-model="currentItem.StartDateTime"
                  type="date"
                  title=""
                  :min-date="minDate"
                  :max-date="maxDate"
                  :formatter="formatterDate"
                  @change="changeStartDate"
                  @confirm="onConfirmStartDate"
                  @cancel="showStartDatePicker = false"
          />
      </van-popup>
      <van-popup v-model="showEndDatePicker" round position="bottom">
<!--            <van-datetime-picker-->
<!--                    v-model="currentItem.EndDateTime"-->
<!--                    type="date"-->
<!--                    title=""-->
<!--                    :min-date="minDate"-->
<!--                    :max-date="maxDate"-->
<!--                    :formatter="formatterDate"-->
<!--                    showToNow-->
<!--                    @change="changeEndDate"-->
<!--                    @confirm="onConfirmEndDate"-->
<!--                    @cancel="showEndDatePicker = false"-->
<!--            />-->
        <VueDatetimePicker
            v-model="currentItem.EndDateTime"
            type="date"
            title=""
            :min-date="minDate"
            :max-date="maxDate"
            :formatter="formatterDate"
            showToNow
            @change="changeEndDate"
            @confirm="onConfirmEndDate"
            @cancel="showEndDatePicker = false"
        />
      </van-popup>
      <van-popup v-model="showPicker" round position="bottom">
          <van-picker
                  title=""
                  show-toolbar
                  :columns="pickerOptions"
                  value-key="dict_name"
                  @cancel="showPicker = false"
                  @confirm="onConfirm"
          />
      </van-popup>
      <van-dialog v-model="showPreview" title="" width="98%" className="dialog-preview" :show-cancel-button="false" :show-confirm-button="false">
            <iframe id="iframePreview" :src="onlineUri?onlineUri:'about:blank'" style="width:100%;height:100vh;border:none;" ></iframe>
            <div style="position: absolute;right: 20px;bottom: 20px; background-color: rgba(255,255,255,.7); width: 40px;height: 40px; border-radius: 40px; ">
                <van-icon name="close" @click="onCancelPreview" size="40px" color="#3A5FFF" />
            </div>
        </van-dialog>
    </div>
</template>

<script>
import Vue from 'vue';
import {
  Toast,
  Uploader,
  Field,
  DatetimePicker,
  Popup,
  Picker,
  Icon,
  Checkbox,
  Tag,
  Button
} from 'vant';
import moment from 'moment';
import Utils from '../utils/Utils';
import Urls from '../utils/Urls';
import Request from '../utils/Request';
import validator from '../validator/validator';
import '@vant/touch-emulator';
import Header from "./Header1";
import Footer from "./Footer";
import VueDatetimePicker from "./DatetimePicker/DatetimePicker";
import SafeBottom from "./SafeBottom";

Vue.use(Uploader);
Vue.use(Field);
Vue.use(Popup);
Vue.use(DatetimePicker);
Vue.use(Picker);
Vue.use(Icon);
Vue.use(Checkbox);
Vue.use(Tag);
Vue.use(Button);
export default {
    name: 'Resume',
    components:{
      SafeBottom,
      Header,
      Footer,
      VueDatetimePicker
    },
    props: {
        msg: String
    },
    data() {
      return {
        app:'',
        loading:false,
        sendEmail:'',
        maxFile:8*1024*1024,
        accept:'.doc,.pdf,.docx,application/*',
        fileIcon: 'word',
        onlineUri:'',
        resumePath:'',
        resumeDetail:{
          Name:"",
          Mobile:"",
          Email:"",
          Sex:"",
          EducationInfo:[{
              School:"",
              Speciality:"",
              StartDate:"",
              EndDate:"",
              Education:""
          }],
          ExperienceInfo:[],
          ProjectInfo:[],
          certificateInfo:[],
          LanguagesSkills:[],
          worksInfo:[],
          internshipInfo:[],
          contestInfo:[],
        },
        checked:false,
        sexList:[{dict_value:'男',dict_name:'男'},
          {dict_value:'女',dict_name:'女'}],
        eduList:[],
        studytypeList:[{dict_value:'是',dict_name:'是'},
          {dict_value:'否',dict_name:'否'}],
        profrankList:[],
        contestList:[],
        languageList:[],
        languagegradeList:[],
        languageskillList:[],
        showStartDatePicker: false,
        showEndDatePicker: false,
        showPicker:false,
        pickerOptions:[],
        pickerType:'',
        minDate: new Date(1950, 0, 1),
        maxDate: new Date(),
        currentItem:{
            EndDateTime:new Date(),
            StartDateTime:new Date(),
        },
        showPreview:false,
      };
    },
    mounted:function(){
        this.app=Utils.getApp();
        this.getInit();
        this.getUserInfo();
    },
    methods: {
        getInit()
        {
          let that=this;
          Request.request(Urls.initialData).then((data)=>{
              if(data)
              {
                that.eduList=data.edu;
                that.profrankList=data.profrank;
                that.contestList=data.competitionname;
                that.languageList=data.language;
                that.languagegradeList=data.englishlevel;
                that.languageskillList=data.languagelevel;
              }
          });
        },
        getUserInfo(){
          let that=this;
          this.loading=true;
          Toast.loading({
            duration: 0,
            forbidClick: true,
          });
          Request.request(Urls.getUserInfo).then((data)=>{
            this.loading=false;
            Toast.clear();
            if(data)
            {
              that.fileIcon=Utils.getFileIcon(data.resumePath);
              that.onlineUri=data.onlineUri;
              that.resumePath=data.resumePath;
              if(data.resumeDetail) {
                let resumeDetail=JSON.parse(data.resumeDetail);
                that.resumeDetail ={...that.resumeDetail,...resumeDetail};
                if(that.resumeDetail.Email)
                {
                  that.sendEmail=that.resumeDetail.Email;
                }
                if(!(that.resumeDetail.EducationInfo && that.resumeDetail.EducationInfo.length>0))
                {
                  that.resumeDetail.EducationInfo=[{
                    School:"",
                    Speciality:"",
                    StartDate:"",
                    EndDate:"",
                    Education:""
                  }];
                }
                if(!(that.resumeDetail.ExperienceInfo && that.resumeDetail.ExperienceInfo.length>0))
                {
                  that.resumeDetail.ExperienceInfo=[];
                }
                if(!(that.resumeDetail.ProjectInfo))
                {
                  that.resumeDetail.ProjectInfo=[];
                }
                if(!(that.resumeDetail.certificateInfo))
                {
                  that.resumeDetail.certificateInfo=[];
                }
                if(!(that.resumeDetail.LanguagesSkills))
                {
                  that.resumeDetail.LanguagesSkills=[];
                }
                else
                {
                  that.resumeDetail.LanguagesSkills.forEach(l=>{
                    l.langtype=l.Languages.indexOf('英语')!=-1?'英语':'其他';
                  });
                }
                if(!(that.resumeDetail.worksInfo))
                {
                  that.resumeDetail.worksInfo=[];
                }
                if(!(that.resumeDetail.internshipInfo))
                {
                  that.resumeDetail.internshipInfo=[];
                }
                if(!(that.resumeDetail.contestInfo))
                {
                  that.resumeDetail.contestInfo=[];
                }
              }
            }
          });
        },
        setPreviewHeight()
        {
          document.getElementById("iframePreview").style.height= document.getElementsByClassName("van-dialog__content").offsetHeight+"px";
        },
        onCancelPreview()
        {
            this.showPreview=false;
        },
        onPreview()
        {
            this.showPreview=true;
            //window.open(this.onlineUri);
        },
        onBeforeReadFile(file) {
            console.log(file)
            let that=this;
            that.name=null;
            if(!file.type)
            {
                Utils.getFileType(file).then(type=>{
                    if(type)
                    {
                        that.name=file.name+'.'+type;
                    }
                    else
                    {
                        Toast('请上传 pdf,docx,doc ');
                        return false;
                    }
                });
            }
            else {
                let suf = Utils.getFileSuffix(file.name);
                if (suf != 'doc' && suf != 'docx' && suf != 'pdf') {
                    Toast('请上传 pdf,docx,doc ');
                    return false;
                }
            }
            if(file.size>this.maxFile)
            {
                Toast('上传文件不能超过8M');
                return false;
            }
            return true;
        },
        onAfterReadFile(file, detail) {
            console.log(file)
            console.log(detail)
            let that=this;
            let upfile=file.file;
            if(that.name)
            {
                upfile=new File([file.file],that.name);
            }
            Toast.loading({
                message: '正在上传',
                duration: 0,
                forbidClick: true,
            });
            Request.requestFile(Urls.uploadResumeFile,upfile).then((data)=>{
                console.log(data);
                Toast.clear();
                if(data)
                {
                  that.fileIcon=Utils.getFileIcon(data.resumePath);
                  that.resumePath=data.resumePath;
                  if(data.resumeDetail) {
                      if(that.onlineUri)
                      {
                          that.$Dialog.confirm({
                              title: '提示',
                              message: '是否根据新的简历更新在线简历内容？',
                          })
                          .then(() => {
                              let resumeDetail=data.resumeDetail;
                              that.resumeDetail ={...that.resumeDetail,...resumeDetail};
                              if(that.resumeDetail.Email)
                              {
                                that.sendEmail=that.resumeDetail.Email;
                              }
                              if(!(that.resumeDetail.EducationInfo && that.resumeDetail.EducationInfo.length>0))
                              {
                                  that.resumeDetail.EducationInfo=[{
                                      School:"",
                                      Speciality:"",
                                      StartDate:"",
                                      EndDate:"",
                                      Education:""
                                  }];
                              }
                              if(!(that.resumeDetail.ExperienceInfo && that.resumeDetail.ExperienceInfo.length>0))
                              {
                                  that.resumeDetail.ExperienceInfo=[];
                              }
                              if(!(that.resumeDetail.ProjectInfo))
                              {
                                  that.resumeDetail.ProjectInfo=[];
                              }
                              if(!(that.resumeDetail.certificateInfo))
                              {
                                that.resumeDetail.certificateInfo=[];
                              }
                              if(!(that.resumeDetail.LanguagesSkills))
                              {
                                that.resumeDetail.LanguagesSkills=[];
                              }
                              else
                              {
                                that.resumeDetail.LanguagesSkills.forEach(l=>{
                                    l.langtype=l.Languages.indexOf('英语')!=-1?'英语':'其他';
                                });
                              }
                              if(!(that.resumeDetail.worksInfo))
                              {
                                that.resumeDetail.worksInfo=[];
                              }
                              if(!(that.resumeDetail.internshipInfo))
                              {
                                that.resumeDetail.internshipInfo=[];
                              }
                              if(!(that.resumeDetail.contestInfo))
                              {
                                that.resumeDetail.contestInfo=[];
                              }
                          })
                          .catch(() => {
                              // on cancel
                          });
                      }
                      else {
                          let resumeDetail=data.resumeDetail;
                          that.resumeDetail ={...that.resumeDetail,...resumeDetail};
                          if(that.resumeDetail.Email)
                          {
                            that.sendEmail=that.resumeDetail.Email;
                          }
                          if(!(that.resumeDetail.EducationInfo && that.resumeDetail.EducationInfo.length>0))
                          {
                            that.resumeDetail.EducationInfo=[{
                                  School:"",
                                  Speciality:"",
                                  StartDate:"",
                                  EndDate:"",
                                  Education:""
                            }];
                          }
                          if(!(that.resumeDetail.ExperienceInfo && that.resumeDetail.ExperienceInfo.length>0))
                          {
                            that.resumeDetail.ExperienceInfo=[];
                          }
                          if(!(that.resumeDetail.ProjectInfo))
                          {
                            that.resumeDetail.ProjectInfo=[];
                          }
                          if(!(that.resumeDetail.certificateInfo))
                          {
                            that.resumeDetail.certificateInfo=[];
                          }
                          if(!(that.resumeDetail.LanguagesSkills))
                          {
                            that.resumeDetail.LanguagesSkills=[];
                          }
                          if(!(that.resumeDetail.worksInfo))
                          {
                            that.resumeDetail.worksInfo=[];
                          }
                          if(!(that.resumeDetail.internshipInfo))
                          {
                            that.resumeDetail.internshipInfo=[];
                          }
                          if(!(that.resumeDetail.contestInfo))
                          {
                            that.resumeDetail.contestInfo=[];
                          }
                      }
                  }
                  that.onlineUri=data.onlineUri;
                }
            })
        },
        delFile()
        {
          let that=this;
          this.$Dialog.confirm({
            title: '提示',
            message: '确认删除吗？',
          })
              .then(() => {
                that.resumePath='';
                that.onlineUri='';
              })
              .catch(() => {
                // on cancel
              });
        },

        formatterDate(type, val) {
            if (type === 'year') {
                return `${val}年`;
            } else if (type === 'month') {
                return `${val}月`;
            }
            return `${val}日`;
        },
        changeStartDate(picker){
            let date=picker.getValues().join('-').replace('年','').replace('月','').replace('日','');
            //console.log(date)
            if(date.indexOf('至今')!=-1)
            {
                return;
            }
            if(this.currentItem.EndDate)
            {
                if(moment(date,'YYYY-MM-DD').isAfter(moment(this.currentItem.EndDate,'YYYY-MM-DD')))
                {
                    if(this.currentItem.StartDate) {
                        picker.setValues(moment(this.currentItem.StartDate).format('YYYY年-MM月-DD日').split('-'));
                    }
                    else
                    {
                        picker.setValues(moment().format('YYYY年-MM月-DD日').split('-'));
                    }
                    Toast('不能大于结束时间');
                    //return false;
                }
            }
        },
        changeEndDate(picker){
            let date=picker.getValues().join('-').replace('年','').replace('月','').replace('日','');
            //console.log(date)
            if(date.indexOf('至今')!=-1)
            {
                return;
            }
            if(this.currentItem.StartDate)
            {
                if(moment(date,'YYYY-MM-DD').isBefore(moment(this.currentItem.StartDate,'YYYY-MM-DD')))
                {
                    if(this.currentItem.EndDate)
                    {
                        picker.setValues(moment(this.currentItem.EndDate).format('YYYY年-MM月-DD日').split('-'));
                    }
                    else
                    {
                        picker.setValues(moment().format('YYYY年-MM月-DD日').split('-'));
                    }
                    Toast('不能小于开始时间');
                    //return false;
                }
            }
        },
        showStartDatePopup(e,item) {
            this.showStartDatePicker = true;
            this.currentItem=item;
            if(item.starttime!=undefined)
            {
              item.StartDate=item.starttime;
            }
            if(item.StartDate)
            {
                item.StartDateTime=moment(item.StartDate,'YYYY-MM-DD').toDate();
            }
            else
            {
                item.StartDateTime=moment().toDate();
            }
        },
        onConfirmStartDate(date){
            this.showStartDatePicker = false;
            console.log(date)
            this.currentItem.StartDateTime=date;
            this.currentItem.StartDate=moment(date).format('YYYY-MM-DD');
            if(this.currentItem.starttime!=undefined)
            {
              this.currentItem.starttime=moment(date).format('YYYY-MM-DD');
            }
        },
        showEndDatePopup(e,item) {
            this.showEndDatePicker = true;
            this.currentItem=item;
            if(item.endtime!=undefined)
            {
              item.EndDate=item.endtime;
            }
            if(item.EndDate)
            {
                item.EndDateTime=item.EndDate=='至今'?item.EndDate:moment(item.EndDate,'YYYY-MM-DD').toDate();
            }
            else
            {
                item.EndDateTime=moment().toDate();
            }
        },
        onConfirmEndDate(date){
            this.showEndDatePicker = false;
            console.log('onConfirmEndDate',date)
            this.currentItem.EndDateTime=date;
            this.currentItem.EndDate=date=='至今'?date:moment(date).format('YYYY-MM-DD');
            console.log('this.currentItem.EndDateTime',date)
            if(this.currentItem.endtime!=undefined)
            {
              this.currentItem.endtime = date == '至今' ? date : moment(date).format('YYYY-MM-DD');
            }
        },

        showPopup(e,item,type) {
            this.showPicker = true;
            this.currentItem=item;
            this.pickerType=type;
            switch (this.pickerType)
            {
              case "sex":
                this.pickerOptions=this.sexList;
                break;
              case "edu":
                this.pickerOptions=this.eduList;
                break;
              case "study":
                this.pickerOptions=this.studytypeList;
                break;
              case "prof":
                this.pickerOptions=this.profrankList;
                break;
              case "contest":
                this.pickerOptions=this.contestList;
                break;
              case "lang":
                this.pickerOptions=this.languageList;
                break;
              case "grade":
                this.pickerOptions=this.languagegradeList;
                break;
              case "skill":
                this.pickerOptions=this.languageskillList;
                break;
            }
        },
        onConfirm(value)
        {
            this.showPicker = false;
            console.log('value',value)
            switch (this.pickerType)
            {
              case "sex":
                this.currentItem.Sex=value.dict_name;
                break;
              case "edu":
                this.currentItem.Education=value.dict_name;
                break;
              case "study":
                this.currentItem.studyType=value.dict_name;
                break;
              case "prof":
                this.currentItem.professionRanking=value.dict_name;
                break;
              case "contest":
                this.currentItem.name=value.dict_name;
                break;
              case "lang":
                this.currentItem.langtype=value.dict_name;
                console.log('langtype',this.currentItem.langtype)
                if(this.currentItem.langtype=='英语')
                {
                  this.currentItem.Languages = this.currentItem.langtype;
                  this.currentItem.grade='';
                  this.currentItem.Score='';
                }
                else
                {
                  this.currentItem.Languages='';
                  this.currentItem.Skills='';
                }
                console.log('Languages', this.currentItem.Languages)
                break;
              case "grade":
                this.currentItem.grade=value.dict_name;
                break;
              case "skill":
                this.currentItem.Skills=value.dict_name;
                break;
            }
        },

        onAddEdu()
        {
            this.resumeDetail.EducationInfo.push({
                School:"",
                Speciality:"",
                StartDate:"",
                EndDate:"",
                Education:""
            });
        },
        onDelEdu(e,i)
        {
            let that=this;
            if(this.resumeDetail.EducationInfo && this.resumeDetail.EducationInfo.length>1) {
                this.$Dialog.confirm({
                    title: '提示',
                    message: '确认删除吗？',
                })
                    .then(() => {
                        // on confirm
                        that.resumeDetail.EducationInfo.splice(i, 1);
                    })
                    .catch(() => {
                        // on cancel
                    });
            }
            else
            {
                Toast('不能在删除了');
            }
        },

        onAddJob()
        {
            this.resumeDetail.ExperienceInfo.push({
                Company: "",
                Title: "",
                StartDate: "",
                EndDate: "",
                Summary: ""
            });
        },
        onDelJob(e,i)
        {
            let that=this;
            //if(this.resumeDetail.ExperienceInfo && this.resumeDetail.ExperienceInfo.length>1) {
                this.$Dialog.confirm({
                    title: '提示',
                    message: '确认删除吗？',
                })
                    .then(() => {
                        // on confirm
                        that.resumeDetail.ExperienceInfo.splice(i, 1);
                    })
                    .catch(() => {
                        // on cancel
                    });
            // }
            // else
            // {
            //     Toast('不能在删除了');
            // }
        },

        onAddPro()
        {
            this.resumeDetail.ProjectInfo.push({
                ProjectName: "",
                StartDate: "",
                EndDate: "",
                ProjectDescription: "",
                Responsibilities: ""
            });
        },
        onDelPro(e,i)
        {
            let that=this;
            // if(this.resumeDetail.ProjectInfo && this.resumeDetail.ProjectInfo.length>1) {
                this.$Dialog.confirm({
                    title: '提示',
                    message: '确认删除吗？',
                })
                    .then(() => {
                        // on confirm
                        that.resumeDetail.ProjectInfo.splice(i, 1);
                    })
                    .catch(() => {
                        // on cancel
                    });
            // }
            // else
            // {
            //     Toast('不能在删除了');
            // }
        },

        onAddIntern()
        {
          this.resumeDetail.internshipInfo.push({
            company: "",
            title: "",
            startDate: "",
            endDate: "",
            jobDetail: ""
          });
        },
        onDelIntern(e,i)
        {
          let that=this;
          //if(this.resumeDetail.internshipInfo && this.resumeDetail.internshipInfo.length>1) {
            this.$Dialog.confirm({
              title: '提示',
              message: '确认删除吗？',
            })
            .then(() => {
              // on confirm
              that.resumeDetail.internshipInfo.splice(i, 1);
            })
            .catch(() => {
              // on cancel
            });
          // }
          // else
          // {
          //   Toast('不能在删除了');
          // }
        },

        onAddWorks()
        {
          this.resumeDetail.worksInfo.push({
            url: "",
            description: "",
          });
        },
        onDelWorks(e,i)
        {
          let that=this;
          //if(this.resumeDetail.worksInfo && this.resumeDetail.worksInfo.length>1) {
            this.$Dialog.confirm({
              title: '提示',
              message: '确认删除吗？',
            })
            .then(() => {
              // on confirm
              that.resumeDetail.worksInfo.splice(i, 1);
            })
            .catch(() => {
              // on cancel
            });
          // }
          // else
          // {
          //   Toast('不能在删除了');
          // }
        },

        onAddCont()
        {
          this.resumeDetail.contestInfo.push({
            name: "",
            description: "",
          });
        },
        onDelCont(e,i)
        {
          let that=this;
          //if(this.resumeDetail.contestInfo && this.resumeDetail.contestInfo.length>1) {
            this.$Dialog.confirm({
              title: '提示',
              message: '确认删除吗？',
            })
            .then(() => {
              // on confirm
              that.resumeDetail.contestInfo.splice(i, 1);
            })
            .catch(() => {
              // on cancel
            });
          // }
          // else
          // {
          //   Toast('不能在删除了');
          // }
        },

        onAddCert()
        {
          this.resumeDetail.certificateInfo.push({
            name: "",
            description: "",
          });
        },
        onDelCert(e,i)
        {
          let that=this;
          //if(this.resumeDetail.certificateInfo && this.resumeDetail.certificateInfo.length>1) {
            this.$Dialog.confirm({
              title: '',
              message: '确认删除吗？',
              theme: 'round-button',
            })
            .then(() => {
              // on confirm
              that.resumeDetail.certificateInfo.splice(i, 1);
            })
            .catch(() => {
              // on cancel
            });
          // }
          // else
          // {
          //   Toast('不能在删除了');
          // }
        },

        onAddLang()
        {
          this.resumeDetail.LanguagesSkills.push({
            langtype:"",
            Languages: "",
            Skills: "",
            grade:"",
            Score:"",
          });
        },
        onDelLang(e,i)
        {
          let that=this;
          //if(this.resumeDetail.LanguagesSkills && this.resumeDetail.LanguagesSkills.length>1) {
            this.$Dialog.confirm({
              title: '',
              message: '确认删除吗？',
              theme: 'round-button',
            })
            .then(() => {
              // on confirm
              that.resumeDetail.LanguagesSkills.splice(i, 1);
            })
            .catch(() => {
              // on cancel
            });
          // }
          // else
          // {
          //   Toast('不能在删除了');
          // }
        },


        saveResume()
        {
            let that=this;
            if(Utils.isBlank(this.resumePath))
            {
                Toast('请上传简历');
                return;
            }
            if(!validator.checkAllResume(this.resumeDetail))
            {
                return;
            }
            let data={
                resumePath:that.resumePath,
                resumeDetail:JSON.stringify(that.resumeDetail)
            }
            Toast.loading({
                duration: 0,
                forbidClick: true,
            });
            Request.requestJson(Urls.saveResumeInfo,data).then((data)=>{
                Toast.clear();
                if(data)
                {
                    Toast('保存成功');
                }
                else
                {
                    Toast('保存失败');
                }
            });

        },

    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .page
    {
      background-color: #F5F7FA;
      /*height: 100%;*/
      flex:1;
      display: flex;
      flex-direction: column;
      overflow: hidden !important;
    }
    .body{
      flex: 1;
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
    }

    .box-split
    {
        height: 0px;
        background-color: #F5F7FA;
    }

    .uploadbox
    {
      box-sizing: border-box;
      margin-left: 20px;
      margin-right: 20px;
      margin-top: 16px;
      margin-bottom: 16px;
      height: 163px;
      background-color: #FFFFFF;
      border: 1.5px dashed #DEE5F4;
      border-radius: 6px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .van-uploader>>> .van-uploader__input-wrapper{
      text-align: center;
    }
    .upload-icon{
      width: 38px;
      height: 45px;
    }
    .upload-text{
      margin-top: 16px;
      font-family: PingFangSC-Medium;
      font-size: 14px;
      color: #20253F;
      line-height: 18px;
      font-weight: 500;
      text-align: center;
    }
    .upload-text-sub{
      margin-top: 8px;
      height: 14px;
      font-family: PingFangSC-Regular;
      font-size: 12px;
      color: #666D7F;
      line-height: 14px;
      font-weight: 400;
      text-align: center;
    }
    .filebox
    {
        background-color: #FFFFFF;
        border-radius: 4px;
        margin-left: 20px;
        margin-right: 20px;
        margin-top: 16px;
        margin-bottom: 16px;
        padding: 10px 12px;
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .filebox-icon
    {
        width: 23px;
        height: 28px;
        vertical-align: middle;
    }
    .filebox-name
    {
        margin-left: 8px;
        flex: 1;
        height: 18px;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #20253F;
        line-height: 18px;
        font-weight: 400;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .filebox-btns
    {
      height: 18px;
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #3A5FFF;
      line-height: 18px;
      font-weight: 400;
    }

    .box2
    {
        background-color: #FFFFFF;
        margin-left: 20px;
        margin-right: 20px;
        margin-top: 0;
        margin-bottom: 10px;
        border-radius: 6px;
        padding: 0 16px;
    }

    .box2-title{
      margin: 10px 20px;
      height: 18px;
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #20253F;
      line-height: 18px;
      font-weight: 500;
      display: flex;
      align-items: center;
    }
    .box2-title-icon{
      display: block;
      width: 3px;
      height: 13px;
      background:linear-gradient(to bottom,#206CFE 0%,#206CFE 50%,red 51%,red 100%);
      margin-right: 8px;
      margin-top: 1px;
    }
    .box2-title-text
    {
      margin: 10px 20px;
      height: 18px;
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #20253F;
      line-height: 18px;
      font-weight: 500;
    }
    .box2-title-text-sub{
      font-family: PingFangSC-Regular;
      font-size: 12px;
      color: #111E36;
      line-height: 18px;
      font-weight: 400;
    }
    .van-cell{
      padding: 16px 0px;
      margin: 0px;
      border-bottom: 1px solid #F8F9FC;
      line-height:initial;
    }
    .van-cell:not(:last-child)::after {
        left: 0px;
        border-bottom: none;
    }
    .van-cell:last-child::after {
      border-bottom: none;
    }
    .van-cell:last-child
    {
      border-bottom: none;
    }
    .van-cell--required::before {
        position: inherit;
        left: 0px;
        font-family: PingFangSC-Regular;
        font-size: 15px;
        color: #F25058;
    }
    .van-field>>> .van-field__label
    {
        width: auto;
        margin-right: 30px;
    }
    .van-field>>> .van-field__label span
    {
      height: 16px;
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #20253F;
      line-height: 16px;
      font-weight: 400;
    }
    .van-field>>> .van-field__value input
    {
        height: 16px;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #20253F;
        line-height: 16px;
        font-weight: 400;
    }
    .van-field>>> input::-webkit-input-placeholder,
    .van-field>>> input::-moz-placeholder,
    .van-field>>> input:-ms-input-placeholder,
    .van-field>>> input::-webkit-input-placeholder,
    .van-field>>> input::placeholder {
      height: 16px;
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #9499B0;
      line-height: 16px;
      font-weight: 400;
    }

    .textarea{
        display:block;
        padding-bottom: 0px;
        border-bottom: none !important;
    }
    .textarea:last-child{
      padding-bottom: 16px;
    }
    .textarea::after {
        border-bottom: none !important;
    }
    .textarea>>>  .van-field__value{
        margin-top: 16px;
    }
    .textarea>>> .van-field__label
    {
        display: inline-block;
    }
    .van-field>>> .van-field__value textarea{
        padding: 16px;
        background: #F2F4F5;
        border-radius: 6px;

        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #20253F;
        line-height: 16px;
        font-weight: 400;
    }
    .van-field>>> textarea::-webkit-input-placeholder,
    .van-field>>> textarea::-moz-placeholder,
    .van-field>>> textarea:-ms-input-placeholder,
    .van-field>>> textarea::-webkit-input-placeholder,
    .van-field>>> textarea::placeholder {
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #9499B0;
      line-height: 16px;
      font-weight: 400;
    }

    .box2-btns
    {
        display: flex;
        flex-direction: row;
        margin: 0 20px 10px;
    }

    .box2-btn-add
    {
        flex:1;
        height: 44px;
        border: none;

        background: #FFFFFF;
        border-radius: 6px;

        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #0055FF;
        font-weight: 400;

        cursor:pointer;
    }

    .box2-btn-del
    {
        flex:1;
        height: 44px;
        border: none;

        background: #FFFFFF;
        border-radius: 6px;

        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #111E36;
        font-weight: 400;

        cursor:pointer;
    }

    .bottom-btns
    {
        background-color: #ffffff;
        padding: 16px;
        width: calc(100% - 32px);
        display: flex;
        flex-direction: row;
        position: fixed;
        bottom: 0px;
        left: 0px;
    }

    .bottom-btn
    {
        flex: 1;
        border: none;

        height: 44px;
        background-image: linear-gradient(270deg, #206CFE 0%, #4C88FF 100%);
        border-radius: 4px;

        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #FFFFFF;
        font-weight: 400;
    }

    .bottom-btn-default
    {
      flex: 1;
      border: none;

      height: 44px;
      background-color: #F5F7FA;
      border-radius: 4px;

      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #20253F;
      font-weight: 400;
    }

    .van-picker>>> .van-picker__confirm {
        font-family: PingFangSC-Medium;
        font-size: 16px;
        color: #3A5FFF;
    }
    .van-picker>>> .van-picker__cancel {
        font-family: PingFangSC-Regular;
        font-size: 16px;
        color: #20253F;
    }

    .van-picker>>> .van-picker-column__item{
        font-family: PingFangSC-Regular;
        font-size: 16px;
        color: #CCCFD8;
    }

    .van-picker>>> .van-picker-column__item--selected{
        font-family: PingFangSC-Medium;
        font-size: 16px;
        color: #3A5FFF;
    }

    .xieyi
    {
      font-family: PingFangSC-Regular;
      font-size: 10px;
      color: #666D7F;
      font-weight: 400;
      margin: 20px;
    }
    .xieyi>>> .van-checkbox{
      align-items: flex-start;
    }
    .xieyi>>> .van-checkbox__label{
      line-height: 1.5;
    }
    .dialog-preview
    {
        height: 98%;
        top: 50%;
    }

    .dialog-preview>>> .van-dialog__footer
    {
        position: relative;
        bottom: 0;
    }

    .popup{

    }
    .popup>>> .van-popup__close-icon--top-right {
      top: 10px;
    }
    .popup>>> .van-popup__close-icon {
      color: #111E36;
    }
    .popup-title{
      margin: 12px 20px;
      height: 18px;
      font-family: PingFangSC-Medium;
      font-size: 17px;
      color: #111E36;
      text-align: center;
      line-height: 18px;
      font-weight: 500;
    }
    .popup-input{
      box-sizing: border-box;
      margin: 16px 20px 4px;
      padding: 12px;
      height: 40px;
      background: rgba(247,249,250,0.50);
      border: 1px solid #E6EBF5;
      border-radius: 4px;
    }
    .popup-input>>> .van-cell{
      padding: 0;
      background-color: transparent;
    }
    .popup-btns
    {
      background-color: #ffffff;
      padding: 16px 20px;
      width: calc(100% - 32px);
      display: flex;
      flex-direction: row;
    }

    .pr{
      padding-bottom: 24px;
      border-bottom: none;
    }
    .pr::after
    {
      content: '说明：请如实填写，面试时需携带相关材料';
      font-size: 12px;
      transform:none;
      color: #3A5FFF;
    }


</style>
<style>
.van-dialog__message{
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #20253F !important;
  text-align: center;
  line-height: 18px;
  font-weight: 400;
}
.van-dialog__cancel{
  height: 40px !important;
  background: #F5F7FA !important;
  border-radius: 4px;

  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #20253F;
  text-align: center;
  font-weight: 400;
}
.van-dialog__confirm
{
  height: 40px !important;
  background: none;
  background-image: linear-gradient(270deg, #206CFE 0%, #4C88FF 100%);
  border-radius: 4px;

  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #FFFFFF;
  letter-spacing: 0;
  text-align: center;
  font-weight: 400;
}
.van-dialog__cancel+.van-dialog__confirm
{
  margin-left: 12px;
}
</style>
